<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-row dense>
				<v-col cols="12" class="d-flex">
					<div style="width: 200px;">
						<v-select :items="yearItems" v-model="query.year" item-text="name" item-value="value"
							label="年份" dense outlined></v-select>
					</div>
					<v-btn class="ml-2" color="info" @click="refresh">查询</v-btn>
					<v-spacer></v-spacer>
					
				</v-col>
			</v-row>
			<v-row dense>
				
				<v-col cols="6">
					<v-card>
						<v-card-title class="d-flex">
							<div>月度支出金额</div>
							<v-spacer></v-spacer>
							<span class="text-h6 mr-3">{{summaryText}}</span>
						</v-card-title>
						<v-card-text>
							<ve-histogram  :data="monthPayOutData" :extend="chartExtend" :judge-width="true" height="400px"  date-empty="暂无数据"></ve-histogram>
						</v-card-text>
					</v-card>
				</v-col>
				
				
				<v-col cols="6">
					<v-card v-if="totalPayRateData.rows.length>0">
						<v-card-title class="d-flex">
							<div>全年总支出占比</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<ve-pie :data="totalPayRateData" :judge-width="true"></ve-pie>
						</v-card-text>
					</v-card>
					
				</v-col>
				<v-col cols="6">
					<v-card v-if="monthIncomesData.rows.length>0">
						<v-card-title class="d-flex">
							<div>月度其他收入金额</div>
							<v-spacer></v-spacer>
							<span class="text-h6 mr-3">{{monthIncomesData.summaryText}}</span>
						</v-card-title>
						<v-card-text>
							<ve-histogram  :data="monthIncomesData" :extend="incomeExtend" :judge-width="true" height="400px"  date-empty="暂无数据"></ve-histogram>
						</v-card-text>
					</v-card>
					
				</v-col>
				
				<v-col cols="6">
					<v-card v-if="totalIncomeRateData.rows.length>0">
						<v-card-title class="d-flex">
							<div>全年其他收入占比</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<ve-pie :data="totalIncomeRateData" :judge-width="true"></ve-pie>
						</v-card-text>
					</v-card>
					
				</v-col>
				
			</v-row>
			
		</v-card-text>

	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "flow-dashboard",
		data() {
			this.chartExtend = {
			 //  title: {
				// text: '缴费&消课收入报表'
			 //  },
			  series: {
				barWidth: 40,
				label:{show:true,position:'top'}
			  }
			},
			this.incomeExtend={
				series: {
					barWidth: 40,
					label:{show:true,position:'top'}
				}
			}
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '数据报表',
						disabled: true
					},
					{
						text: '支出报表',
						disabled: true
					},
				],
				shopId:"",
				yearItems:[],
				summaryText:"",
				query: {
					year:""+new Date().getFullYear()
				},
				monthPayOutData: {
					columns: ['月份', '支出金额'],
					rows: [], 
				},
				totalPayRateData: {
					columns: ['支出类型', '金额'],
					rows: [], 
				},
				monthIncomesData: {
					columns: ['月份', '收入金额'],
					rows: [], 
					summaryText:"",
				},
				totalIncomeRateData: {
					columns: ['收入类型', '金额'],
					rows: [], 
				},
			}
		},
		mounted() {

		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.generateYearItems();
			// 默认本年度
			const now = new Date();
			const nowYear = now.getFullYear();
			this.query.year = nowYear.toString();
			
			
			this.getChartData();
			this.getTotalPayRateList();
			this.getMonthIncomesData();
			this.getTotalIncomeRateList();

		},
		methods: {
			generateYearItems(){
				let fromYear = 2018;
				const now = new Date();
				const nowYear = now.getFullYear();
				
				for (let i = fromYear; i <= nowYear; i++) {
					this.yearItems.push({value:i.toString(),name:i.toString()+"年"})
				}
			},
			refresh(){
				this.getChartData();
				this.getTotalPayRateList();
				this.getMonthIncomesData();
				this.getTotalIncomeRateList();
			},
			getChartData() {
				const that = this;

				let url = `/report/payout/dashboard/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
					if (response.data["code"] === 200) {
						
						console.log(response.data["data"]["dataList"]);
						
						const dataList = response.data["data"]["dataList"] || [];
						
						let payOutList = [];
					
						if (dataList.length > 0){
							dataList.forEach((item,index)=>{
								let monthPay = {"月份":item.month,"支出金额":item.payAmount}
								payOutList.push(monthPay);
							})
						}
						// 月支出金额
						that.monthPayOutData.rows = payOutList;
					

						that.summaryText  =  response.data["data"]["summaryText"];
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				
					
				})
			},
			getMonthIncomesData() {
				
				// 获取月度其他收入数据
				const that = this;
			
				let url = `/report/month/other/income/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
					if (response.data["code"] === 200) {
						console.log("获取其他收入");
						console.log(response.data["data"]["dataList"]);
						console.log("获取其他收入");
						const dataList = response.data["data"]["dataList"] || [];
						
						let incomesList = [];
					
						if (dataList.length > 0){
							dataList.forEach((item,index)=>{
								let monthPay = {"月份":item.month,"收入金额":item.amount}
								//let monthPay = {"月份":item.month,"活动收费":item.IN_ACTIVITY,"订单收入":item.IN_ORDER_INCOME,"广告收入":item.IN_AD,"其他收入":item.IN_OTHER}
								incomesList.push(monthPay);
							})
						}
						// 月收入金额
						that.monthIncomesData.rows = incomesList;
					
						that.monthIncomesData.summaryText  =  response.data["data"]["summaryText"];
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				
					
				})
			},
			getTotalPayRateList(){
				// 获取总支出占比
				const that = this;
				let url = `/report/payout/rate/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						const dataList = response.data["data"]["dataList"] || [];
					
						console.log(dataList);
						
						that.totalPayRateData.rows = dataList;
						
						return
					}
				})
			},
			getTotalIncomeRateList(){
				// 获取总收入占比
				const that = this;
				let url = `/report/other/income/rate/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						const dataList = response.data["data"]["dataList"] || [];
					
						console.log('income',dataList);
						
						that.totalIncomeRateData.rows = dataList;
						
						return
					}
				})
			},
			
		}
	}
</script>

<style>
</style>
